var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsCut = function SvgMetricsCut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.882 24 38.766 9.234 24 3.118 9.234 9.234 3.118 24l6.116 14.766L24 44.882l14.765-6.116zM24 44.881 21.689 26.31 3.118 24l18.571-2.311L24 3.118l2.311 18.571L44.882 24l-18.571 2.311z"
  })))));
};
export default SvgMetricsCut;